(function () {
    'use strict';

    function subscriptionSignupController(plans, sessionData, $window, $routeParams, $scope, $location) {
        var vm = this;
        vm.sessionData = sessionData;
        vm.selectedPlanId = '';
        vm.iframeIsReady = false;
        vm.iframeSource = '';
        vm.routeFirstLoaded = false;

        $scope.$on("$stateChangeSuccess", function (event, toState, toParams, fromState, fromParams) {
            vm.selectedPlanId = toParams.planId;
            vm.routeFirstLoaded = true;

            $location.search({});
        });

        $scope.$watch(function () { return vm.selectedPlanId; }, function (newVal, oldVal) {
            if (vm.routeFirstLoaded && newVal !== oldVal) {
                var path = $location.path();
                if (path.indexOf(oldVal) !== -1) {
                    $location.path(path.replace(oldVal, newVal));
                }
                else {
                    $location.path(path + '/' + newVal);
                }
            }
        });

        var maxPlanPrice = Math.max.apply(null, plans.map(function (plan) {
            if (plan.PeriodUnit === 'month') {
                return plan.Price * 12;
            }

            return plan.Price;
        }));

        plans.forEach(function (plan) {
            var totalCost = plan.Price;
            if (plan.PeriodUnit === 'month') {
                totalCost = totalCost * 12;
            }
            plan.AnnualSavings = Math.max(maxPlanPrice - totalCost, 0);
        });

        vm.plans = plans;

        vm.loadSignupForm = function () {
            throw new Error('no signup form implementation');
        }
    }

    subscriptionSignupController.$inject = ['plans', 'sessionData', '$window', '$routeParams', '$scope', '$location'];

    angular.module('ecap.subscriptions').controller('subscriptionSignupController', subscriptionSignupController);
})();
